// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function PorterStoreFormField(Props) {
  var label = Props.label;
  var value = Props.value;
  var onChange = Props.onChange;
  var requiredOpt = Props.required;
  var disabledOpt = Props.disabled;
  var required = requiredOpt !== undefined ? requiredOpt : false;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  return React.createElement("div", {
              className: "ps-form-field"
            }, React.createElement("label", {
                  className: "ps-form-field__label"
                }, label, required ? React.createElement("span", {
                        className: "ps-form-field__required"
                      }, "*") : null), React.createElement("input", {
                  className: "ps-form-field__input" + (
                    disabled ? " ps-form-field__input--disabled" : ""
                  ),
                  disabled: disabled,
                  type: "text",
                  value: value,
                  onChange: (function ($$event) {
                      return Curry._1(onChange, $$event.target.value);
                    })
                }));
}

var make = PorterStoreFormField;

export {
  make ,
  
}
/* react Not a pure module */
